<template>
  <div class="page">
    <div class="row">
      <div class="sm-12">
        <div class="box-page">
          <div class="row">
            <div class="sm-12">
              <div class="title">
                <i class="mdi mdi-chart-histogram"></i>
                <h2>Informe de Rendimentos</h2>
              </div>
            </div>
          </div>
          <form v-if="sistema == 'C'" @submit.prevent.stop="loadCondominio">
            <div class="row">
              <div class="sm-6 md-4">
                <label>
                  Ano:
                  <input
                    v-model="ano"
                    type="number"
                    placeholder="Ano"
                    :max="ano_maximo" />
                </label>
              </div>
              <div class="sm-6 md-4">
                <button
                  type="submit"
                  class="button secondary full"
                  style="margin-top: 20px"
                  disabled
                  v-if="gerando">
                  Gerando...
                </button>
                <button
                  type="submit"
                  class="button secondary full"
                  style="margin-top: 20px"
                  v-else>
                  Gerar extrato
                </button>
              </div>
            </div>
          </form>
          <form
            v-if="sistema == 'A'"
            @submit.prevent.stop="loadInformesAluguel">
            <div class="row">
              <div class="sm-6 md-4">
                <label>
                  Ano:
                  <input
                    v-model="ano"
                    type="number"
                    placeholder="Ano"
                    :max="ano_maximo" />
                </label>
              </div>
              <div class="sm-6 md-4">
                <button
                  type="submit"
                  class="button secondary full"
                  style="margin-top: 20px"
                  disabled
                  v-if="gerando">
                  Gerando...
                </button>
                <button
                  type="submit"
                  class="button secondary full"
                  style="margin-top: 20px"
                  v-else>
                  Gerar extrato
                </button>
              </div>
            </div>
          </form>
          <div class="row">
            <div class="sm-12">
              <div class="reponsive-table">
                <table v-if="filiais.length != 0">
                  <thead>
                    <tr>
                      <th>Filial</th>
                      <th>Ano</th>
                      <!--<th>Liberado</th>-->
                      <th width="250"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <Filial
                      :filial="filial"
                      v-for="filial in filiais"
                      :key="filial.CodFilial">
                    </Filial>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="sm-12">
              <p v-if="sistema == 'A'">
                Sr(a) Proprietário(a), por precaução, informamos que caso você
                opte por fazer a sua declaração de IRRF sem a conferência dos
                valores informados na DIRF do seu locatário, pessoa jurídica, e
                houver divergência você poderá ter que retificá-la.
              </p>
            </div>
          </div>
          <!--
        <form v-if="sistema=='A'">
            <div class="row">
                <div class="sm-6 md-4">
                    <label>
                        De:
                        <input v-model="data_de" type="date" placeholder="De" />
                    </label>
                </div>
                <div class="sm-6 md-4">
                    <label>
                        Até:
                        <input v-model="data_ate" type="date" placeholder="Até" />
                    </label>
                </div>
                <div class="sm-6 md-4">
                    <button class="button secondary full" style="margin-top: 20px;">GERAR EXTRATO</button>
                </div>
            </div>
        </form>
        -->
          <!--
        <div class="row">
            <div class="sm-12">
                <hr />
            </div>
            <div class="sm-12 md-4">
                <p class="text-primary-darker-1">
                    <strong>Condomínio:</strong>
                    Residencial Montpelier
                </p>
            </div>
            <div class="sm-12 md-4">
                <p class="text-primary-darker-1">
                    <strong>CNPJ:</strong>
                    99.999.999/9999-99
                </p>
            </div>
            <div class="sm-12 md-4">
                <p class="text-primary-darker-1">
                    <strong>Abreviação:</strong>
                    R440
                </p>
            </div>
            <div class="sm-12">
                <p class="text-primary-darker-1">
                    <strong>Endereço:</strong>
                    DOUTOR MÁRIO SPERB, 305, JARDIM AMÉRICA, SAO LEOPOLDO
                </p>
                <hr />
            </div>
        </div>

        <div class="row">
            <div class="sm-12">
                <ul class="flex flex-wrap">
                    <li v-for="ano in [2016,2017,2018,2019]" :key="ano">
                        <a href="#" class="button secondary" style="margin-right: 20px; color: #fff;">
                            <i class="mdi mdi-link"></i>    
                            Ano-Calendário {{ ano }}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        -->
          <iframe style="display: none" ref="hidden_iframe"></iframe>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import api from "/plugins/api";
import { DateTime } from "luxon";
import Filial from "./informe-rendimentos/filial.vue";
export default {
  components: {
    Filial,
  },
  data() {
    return {
      gerando: false,
      errors: [],
      data_de: null,
      data_ate: null,
      ano: DateTime.local().toFormat("yyyy"),
      filiais: [],
    };
  },
  computed: {
    ano_maximo() {
      return +DateTime.local().toFormat("yyyy");
    },
    condominio() {
      return this.$store.getters.condominio;
    },
    codigo_condominio() {
      if (!this.condominio) {
        return null;
      }
      return this.condominio.codigo;
    },
    imovel() {
      return this.$store.getters.imovel;
    },
    codigo_imovel() {
      if (!this.imovel) {
        return null;
      }
      return this.imovel.codigo;
    },
    relacao() {
      return this.$store.getters.relacao;
    },
    sistema() {
      if (!this.relacao) {
        return null;
      }
      return this.relacao.sistema;
    },
    jwt() {
      return this.$store.state.jwt;
    },
  },
  methods: {
    async loadInformesAluguel() {
      try {
        if (this.gerando) {
          return;
        }
        if (!this.codigo_imovel) {
          return;
        }
        if ("" == this.ano || 0 == +this.ano) {
          throw new Error("Informe o ano");
        }
        this.gerando = true;
        this.errors = [];
        this.filiais = [];

        let { data: filiais } = await api.get(
          `aluguel/informe-rendimento/${this.ano}/filiais`
        );
        this.filiais = filiais;
      } catch (err) {
        let text =
          err.message || "Não foi possível carregar o informe de rendimentos.";

        if (err.response && err.response.data) {
          text = err.response.data.error;
        }
        Swal.fire({
          icon: "error",
          title: "Oops",
          text,
        });
        console.error(err);
        this.errors = [...this.errors, err];
      }
      this.gerando = false;
    },
    async loadCondominio() {
      try {
        if (this.gerando) {
          return;
        }
        if (!this.codigo_condominio) {
          return;
        }
        if ("" == this.ano || 0 == +this.ano) {
          throw new Error("Informe o ano");
        }
        this.errors = [];
        this.gerando = true;
        let { data } = await api.get(
          `condominios/${this.codigo_condominio}/informe-rendimento/${this.ano}`,
          {
            params: {
              tipo_relacao: "S",
            },
          }
        );
        this.$refs.hidden_iframe.setAttribute(
          "src",
          `api/condominios/${this.codigo_condominio}/informe-rendimento/download/${data.arquivo}?jwt=${this.jwt}&ano=${this.ano}`
        );
        if (
          "undefined" != typeof cordova &&
          "undefined" != typeof cordova.InAppBrowser
        ) {
          cordova.InAppBrowser.open(
            `api/condominios/${this.codigo_condominio}/informe-rendimento/download/${data.arquivo}?jwt=${this.jwt}&ano=${this.ano}`,
            "_system"
          );
        }
      } catch (err) {
        let text =
          err.message || "Não foi possível carregar o informe de rendimentos.";

        if (err.response && err.response.data) {
          text = err.response.data.error;
        }
        Swal.fire({
          icon: "error",
          title: "Oops",
          text,
        });
        console.error(err);
        this.errors = [...this.errors, err];
      }
      this.gerando = false;
    },
  },
};
</script>
<style lang="less" scoped>
form {
  button {
    margin-top: 1.25em;
  }
}
ul {
  list-style: none;
  li {
    a {
      display: block;
      color: black;
      font-weight: bold;
      padding: 0.5em;
    }
  }
}
</style>
